import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import AuthGuard from 'utils/route-guard/AuthGuard';
// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery, Grid, Link } from '@mui/material';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { getMenuItems } from 'menu-items/document';
import { drawerWidth } from 'store/constant';
import { SET_MENU } from 'store/actions';
import { useHeaderVisibility } from '../../hooks/useHeaderVisibility';

// assets
import { IconChevronRight } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { API } from 'utils/api';

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open, leftDrawerOpened, siderBarWidth }) => ({
  ...theme.typography.mainContent,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  transition: theme.transitions.create(
    'margin',
    open
      ? {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        }
      : {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }
  ),
  transition: 'width 0.2s linear',
  [theme.breakpoints.up('md')]: {
    marginLeft: leftDrawerOpened ? (open ? 0 : -(siderBarWidth - 20)) : '0px',
    width: `calc(100% - ${siderBarWidth}px)`
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: leftDrawerOpened ? '20px' : '0px',
    width: `calc(100% - ${siderBarWidth}px)`,
    padding: '16px'
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: leftDrawerOpened ? '10px' : '0px',
    width: `calc(100% - ${siderBarWidth}px)`,
    padding: '16px',
    marginRight: '10px'
  }
}));

// ==============================|| MAIN LAYOUT ||============================== //

const DocumentLayout = () => {
  const [navigation, setNavigation] = useState(null);
  // const navigation = await getMenuItems();
  
  const shouldDisplayHeader = useHeaderVisibility();
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  // Handle left drawer
  const leftDrawerOpened = useSelector((state) => state.customization.opened);
  const dispatch = useDispatch();
  const handleLeftDrawerToggle = () => {
    dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
  };
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function getNavigation() {
      const menuItems = await getMenuItems();
      setNavigation(menuItems);
    }
    getNavigation();
  }, []);

  const location = useLocation();
  const siderBarWidth = leftDrawerOpened ? drawerWidth : 0;
  return (
    <Box sx={{ display: 'flex', overflowY: 'hidden' }}>
      <CssBaseline />
      {shouldDisplayHeader && (
        <AppBar
          enableColorOnDark
          position="fixed"
          color="inherit"
          elevation={0}
          sx={{
            bgcolor: theme.palette.background.default,
            transition: leftDrawerOpened ? theme.transitions.create('width') : 'none',
            height: '56px',
            //borderBottom:'1px gray solid',
            boxShadow: '0px 1px 8px 0px #0000000F',
            zIndex: 99
          }}
        >
          <Toolbar sx={{ py: '17px', pl: '20px' }}>
            <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
          </Toolbar>
        </AppBar>
      )}
      <Sidebar user={user} drawerOpen={!matchDownMd ? leftDrawerOpened : !leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
      <Main
        leftDrawerOpened={leftDrawerOpened}
        siderBarWidth={siderBarWidth}
        theme={theme}
        open={leftDrawerOpened}
        style={{
          marginTop: shouldDisplayHeader ? '' : '80px',
          background: '#FFFFFF' ,//'linear-gradient(#F4F7FF 1%, #FFFFFF 10%)',
          borderRadius: '0px',
          padding: location.pathname.includes('exploration_center') || location.pathname.includes('cueWordproject') ? '0px' : undefined
        }}
      >
       
        <div
          style={{
            minHeight:
              location.pathname.includes('exploration_center') || location.pathname.includes('cueWordproject')
                ? 'calc(100vh - 56px)'
                : 'calc(100vh - 98px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
          {/* <AuthGuard> */}
            <Grid flex={1} style={{ display: 'flex', flexDirection: 'column' }}>
              <Outlet />
            </Grid>
          {/* </AuthGuard> */}
        </div>

        <Footer/> 
      </Main>
    </Box>
  );
};

export default DocumentLayout;
